import React, { useState, useEffect } from 'react'
import Grid from '@mui/material/Grid2'
import { Button, Box, Typography, Stack } from '@mui/material'
import { styled, alpha } from '@mui/material/styles'
import { Link, useLocation } from 'react-router-dom'
import { RichTreeView } from '@mui/x-tree-view/RichTreeView'
import { TreeItem, TreeItemProps, treeItemClasses } from '@mui/x-tree-view'
import { AlignVerticalTop, BorderTop, Height } from '@mui/icons-material'
import { MUI_X_PRODUCTS, apiGroupList } from './MUI_X_PRODUCTS'
import { useTreeViewApiRef } from '@mui/x-tree-view/hooks/useTreeViewApiRef'
import AccountManage from './AccountManage'
import LogManage from './LogManage'
import Tab from '@mui/material/Tab'
import TabContext from '@mui/lab/TabContext'
import TabList from '@mui/lab/TabList'
import TabPanel from '@mui/lab/TabPanel'
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline'
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline'
import Api from '../../../Api/Api'
import secureLocalStorage from 'react-secure-storage'

const styles1 = {
  grid1: {
    padding: 4,
    background: '#2C2D33',
    borderRadius: '10px',
    border: '1px solid #afafaf',
    borderImageSlice: 1,
    borderImage:
      'linear-gradient(166.93deg, #afafaf 3.24%, rgba(96, 96, 96, 0) 96.43%),linear-gradient(317.92deg, rgba(255, 255, 255, 0.6) 1.48%, rgba(0, 0, 0, 0) 37.95%)',
  },
}

const StyledTab = styled(Tab)(({ theme }) => ({
  color: '#807F88',
  fontFamily: 'Noto Sans KR',
  fontSize: '20px',
  fontWeight: 500,
  lineHeight: '28.96px',
  textAlign: 'left',
  textUnderlinePosition: 'from-font',
  textDecorationSkipInk: 'none',

  '&.Mui-selected': {
    fontWeight: 700,
    color: '#FFFFFF',
    borderBottom: '7px solid',
    // border색깔 시작
    borderImage: 'linear-gradient(89.58deg, #628eff 10%, #8740cd 57.32%, #580475 99.08%)',
    borderImageSlice: 1,
    // border색깔 끝
  },
  '&:hover': {
    fontWeight: 700,
    color: '#FFFFFF',
  },
}))
let groupListTemp = []
let groupListTemp2 = []
let groupListTemp3 = []
let tree = []
let select_ITEM_ID = 0

export default function ManageOrg() {
  const [OrgData, setOrgData] = useState([])
  const loginId = secureLocalStorage.getItem('loginId')

  const [valueTab, setValueTab] = React.useState('/User/SysManage/ManageOrg')
  const [value, setValue] = React.useState('1')

  const [groupList, setGroupList] = React.useState([])
  const [groupList2, setGroupList2] = React.useState([])
  const [groupList3, setGroupList3] = React.useState([])
  const [groupSelect, setGroupSelect] = React.useState([])
  const [expandedItems, setExpandedItems] = React.useState(['1100', '1000'])

  const location = useLocation()
  React.useEffect(() => {
    setValueTab(location.pathname.toString())
  }, [location.pathname])

  useEffect(() => {
    Org()
  }, [])
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const Org = async () => {
    try {
      const response = await Api.get('/api/v1/orgn')
      // const response = await Api.get('/api/v1/orgn', {
      //   withCredentials: true,
      // })
      if (response.status === 200) {
        setOrgData(response.data)
      }
      console.log('OrgData response.data:', response.data)
    } catch (e) {
      console.log('Org_manageOrg exception', e)
    }
  }
  const getOrgOne = async (param) => {
    try {
      const response = await Api.get(`/api/v1/orgn/${param}`)
      // const response = await Api.get('/api/v1/orgn', {
      //   withCredentials: true,
      // })
      if (response.status === 200) {
        console.log('getOrgOne:', response.data)
        // setGroupSelect(response.data)
        return response.data
      }
    } catch (e) {
      console.log('getOrgOne exception', e)
    }
  }

  const handleChange = (event, newValue) => {
    setValue(newValue)
  }

  const getItemId2 = (item) => `${item.orgid}`
  const label2 = (item) => `${item.orgn}`

  const CustomTreeItem = ({ label, ...props }) => {
    const handleDeleteClick = async () => {
      //id부터 하위까지 삭제
      const selectRow = await getOrgOne(props.itemId)

      // const findValue = findIndexValue(props.itemId)
      // console.log(`find in groupList delete: ${JSON.stringify(groupList[findValue], null, 2)}`)
      console.log(`delete item: ${JSON.stringify(selectRow)}`)
    }
    const handleAddClick = async () => {
      //id를 부모Id로 하는 부서 만들기
      const selectRow = await getOrgOne(props.itemId)
      // const findValue = findIndexValue(props.itemId)
      // console.log(`find in groupList add parent id: ${JSON.stringify(groupList[findValue], null, 2)}`)
      // console.log(`to be add parant item id: ${props.itemId}`)
      console.log(`add item: ${JSON.stringify(selectRow)}`)
    }

    return (
      <TreeItem
        label={
          <Stack direction="row" justifyContent="space-between">
            {label}
            {/* {!props.children && <button onClick={handleEditClick}>Edit</button>} */}
            <Stack direction="row">
              {
                <Button onClick={handleAddClick} sx={{ width: 24, height: 24, color: '#90be6d' }}>
                  <AddCircleOutlineIcon />
                </Button>
              }
              {
                <Button onClick={handleDeleteClick} sx={{ width: 24, height: 24, color: '#f07167' }}>
                  <RemoveCircleOutlineIcon />
                </Button>
              }
            </Stack>
          </Stack>
        }
        {...props}
      />
    )
  }

  const CustomTreeItem2 = styled(CustomTreeItem)(({ theme }) => ({
    '& .MuiTreeItem-content.Mui-selected.Mui-focused': {
      borderLeft: '10px solid #7E73FF',
      color: '#ffffff',
    },
    color: theme.palette.grey[200],
    fontFamily: 'Noto Sans KR',
    fontSize: '14px',
    [`& .${treeItemClasses.content}`]: {
      background: '#D9D9D9',
      border: '1px solid #000',
      borderRadius: theme.spacing(0.5),
      padding: theme.spacing(0.5, 1),
      margin: theme.spacing(0.2, 0),
      [`& .${treeItemClasses.label}`]: {
        // transform: 'translateY(25%)',
        textAlign: 'left',
        fontSize: '0.8rem',
        fontWeight: 500,
      },
      position: 'relative',
      '&:before': {
        pointerEvents: 'none',
        content: '""',
        position: 'absolute',
        width: 13,
        left: -16,
        top: 12,
        borderBottom: `1px dashed ${alpha(theme.palette.text.primary, 0.4)}`,
      },
      '&.Mui-selected.Mui-focused:before': {
        pointerEvents: 'none',
        content: '""',
        position: 'absolute',
        width: 13,
        left: -27,
        top: 12,
        borderBottom: `1px dashed ${alpha(theme.palette.text.primary, 0.4)}`,
      },
    },
    [`& .${treeItemClasses.iconContainer}`]: {
      borderRadius: '50%',
      backgroundColor: theme.palette.primary.dark,
      padding: theme.spacing(0, 1.2),
      ...theme.applyStyles('light', {
        backgroundColor: alpha(theme.palette.primary.main, 0.25),
      }),
      ...theme.applyStyles('dark', {
        color: theme.palette.primary.contrastText,
      }),
    },
    [`& .${treeItemClasses.groupTransition}`]: {
      marginLeft: 15,
      paddingLeft: 18,
      borderLeft: `1px dashed ${alpha(theme.palette.text.primary, 0.4)}`,
    },
    // [`& .${treeItemClasses.groupTransition} li:last-child`]: {
    //   marginLeft: 15,
    //   paddingLeft: 18,
    //   borderLeft: `1px dashed  ${alpha(theme.palette.text.primary, 0.4)}`,
    // },
    ...theme.applyStyles('light', {
      color: theme.palette.grey[800],
    }),
  }))

  const apiRef = useTreeViewApiRef()

  const groupClick = (param) => {
    console.log('groupClick 클릭 param:', param)
    getOrgOne(param)
  }
  const handleExpandedItemsChange = (event, itemIds) => {
    console.log('handleExpandedItemsChange itemIds:', itemIds)
    setExpandedItems(itemIds)
  }

  const handleExpandClick = () => {
    setExpandedItems((oldExpanded) => (oldExpanded.length === 0 ? getAllItemsWithChildrenItemIds() : []))
  }
  const getAllItemsWithChildrenItemIds = () => {
    let itemIds = []
    const registerItemId = (item) => {
      if (item.children?.length) {
        itemIds.push(`${item.ITEM_ID}`)
        item.children.forEach(registerItemId)
      }
    }

    groupList2.forEach(registerItemId)

    return itemIds
  }
  function attachChildren(item, data) {
    const children = data.filter((d) => d.PARENT_ID === item.ITEM_ID).map((d) => attachChildren(d, data))

    return children.length ? { ...item, children } : item
  }

  // React.useEffect(() => {
  //   test()
  // }, [])

  // function test() {
  //   groupListTemp = []
  //   groupListTemp3 = []

  //   apiGroupList.map((data) => {
  //     groupListTemp.push(data)
  //   })

  //   const Filtered_groupListTemp = groupListTemp.reduce((acc, current) => {
  //     const x = acc.find((item) => item.ITEM_ID === current.ITEM_ID)
  //     if (!x) {
  //       return acc.concat([current])
  //     } else {
  //       // console.log(current);
  //       return acc
  //     }
  //   }, [])

  //   setGroupList(Filtered_groupListTemp)
  //   // console.log('get_Group_list_Filtered_groupListTemp:', Filtered_groupListTemp)
  //   Filtered_groupListTemp.map((item) => {
  //     const split_text = item.ID_PATH.split('->')
  //     // console.log('split_text:', split_text)
  //     const tempObject = {
  //       CLEVEL: item.CLEVEL,
  //       ID_PATH: item.ID_PATH,
  //       ITEM_ID: item.ITEM_ID,
  //       ITEM_NAME: item.ITEM_NAME,
  //       PARENT_ID: item.PARENT_ID,
  //       dense_rank: item.dense_rank,
  //       rank: item.rank,
  //       row_num: item.row_num,
  //       ID_PATH_LIST: split_text,
  //       createdDate: item.createdDate,
  //       description: item.description,
  //     }
  //     groupListTemp3.push(tempObject)
  //   })
  //   // console.log(JSON.stringify(Filtered_groupListTemp))
  //   groupListTemp2 = []
  //   const result_1 = attach_funtion(Filtered_groupListTemp[0], Filtered_groupListTemp)
  //   groupListTemp2.push(result_1)
  //   setGroupList2(groupListTemp2)
  //   const Filtered_groupListTemp3 = groupListTemp3.reduce((acc, current) => {
  //     const x = acc.find((item) => item.ITEM_ID === current.ITEM_ID)
  //     if (!x) {
  //       return acc.concat([current])
  //     } else {
  //       // console.log(current);
  //       return acc
  //     }
  //   }, [])

  //   setGroupList3(Filtered_groupListTemp3)
  //   tree = []
  //   buildTree(tree, Filtered_groupListTemp3, 1000)
  //   // console.log('tree:', tree)
  //   setGroupList2(tree)
  //   // console.dir(attachChildren(Filtered_groupListTemp[0], Filtered_groupListTemp), { depth: null })
  //   // console.log(result_1)
  // }

  // function attach_funtion(item1, item2) {
  //   return attachChildren(item1, item2)
  // }

  // function buildTree(treeObject, sourceArray, parent_id) {
  //   const nodes = sourceArray.filter((item) => item.PARENT_ID === parent_id)

  //   for (const node of nodes) {
  //     const id = node.ITEM_ID

  //     node.children = []

  //     buildTree(node.children, sourceArray, id)

  //     treeObject.push(node)
  //   }
  // }

  // function findIndexValue(param) {
  //   const findIndexTemp = groupList.findIndex((item) => item.ITEM_ID === parseInt(param))
  //   console.log(findIndexTemp)
  //   return findIndexTemp
  // }

  return (
    <div>
      <TabContext value={valueTab.toString()}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <TabList
            sx={{ marginLeft: 3 }}
            TabIndicatorProps={{
              style: {
                display: 'none',
              },
            }}
            onChange={handleChange}
            aria-label="lab API tabs example"
          >
            <StyledTab
              label="조직관리"
              component={Link}
              to="/User/SysManage/ManageOrg"
              value="/User/SysManage/ManageOrg"
            />
            <StyledTab
              label="계정관리"
              component={Link}
              to="/User/SysManage/AccountManage"
              value="/User/SysManage/AccountManage"
            />
            <StyledTab
              label="로그관리"
              component={Link}
              to="/User/SysManage/LogManage"
              value="/User/SysManage/LogManage"
            />
          </TabList>
        </Box>
        <TabPanel value="/User/SysManage/ManageOrg">
          <Grid container>
            <Grid size={12} sx={styles1.grid1}>
              {/* 원본 트리 뷰*/}
              {/* <Box sx={{ minHeight: 352, minWidth: 250 }}>
                <RichTreeView
                  expansionTrigger="iconContainer"
                  defaultExpandedItems={['grid']}
                  slots={{ item: CustomTreeItem2 }}
                  items={MUI_X_PRODUCTS}
                />
              </Box> */}
              {/* 변환한 트리 뷰 */}
              <RichTreeView
                slots={{ item: CustomTreeItem2 }}
                expandedItems={expandedItems}
                onExpandedItemsChange={handleExpandedItemsChange}
                items={OrgData}
                getItemId={getItemId2}
                getItemLabel={label2}
                apiRef={apiRef}
                expansionTrigger="content"
                onItemClick={(event, itemId) => groupClick(itemId)}
              />
            </Grid>
          </Grid>
        </TabPanel>
        <TabPanel value="/User/SysManage/AccountManage">
          <AccountManage />
        </TabPanel>
        <TabPanel value="/User/SysManage/LogManage">
          <LogManage />
        </TabPanel>
      </TabContext>
    </div>
  )
}
